// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.pageItem {
  width: 42px;
  height: 42px;
  border: 2px solid #68ad3f;
  color: #68ad3f;
  border-radius: 4px;
  padding: 8px;
  text-align: center;
  cursor: pointer;
  font-weight: 500;
  font-size: 16px;
}
.page-gap {
  gap: 18px;
}
.pageItemSelected {
  width: 42px;
  height: 42px;
  border: 2px solid #68ad3f;
  color: #ffffff;
  background-color: #68ad3f;
  border-radius: 4px;
  padding: 8px;
  text-align: center;
  cursor: pointer;
  font-weight: 500;
  font-size: 16px;
}
.prevNext {
  color: #68ad3f;
  cursor: pointer;
  font-weight: 500;
  font-size: 16px;
}
.prevNextDisabled {
  color: #68ad3f;
  font-weight: 500;
  font-size: 16px;
  opacity: 0.3;
}
.pageItem:hover {
  color: #ffffff;
  border: 2px solid #fbb040;
  background-color: #fbb040;
}
.mob {
  display: none;
}

@media only screen and (min-width: 0px) and (max-width: 800px) {
  .page-gap {
    gap: 10px;
  }
}
@media only screen and (min-width: 0px) and (max-width: 767px) {
  .pageItem {
    width: 20px;
    height: 20px;
    font-size: 10px;
    padding: 2px;
  }
  .pageItemSelected {
    width: 20px;
    height: 20px;
    font-size: 10px;
    padding: 2px;
  }

  .prevNext {
    font-size: 20px;
  }
  .prevNextDisabled {
    font-size: 20px;
  }
  .mob {
    display: block;
  }
  .web {
    display: none;
  }
}
`, "",{"version":3,"sources":["webpack://./src/Components/Pagination/PaginationNew.css"],"names":[],"mappings":"AAAA;EACE,WAAW;EACX,YAAY;EACZ,yBAAyB;EACzB,cAAc;EACd,kBAAkB;EAClB,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,eAAe;AACjB;AACA;EACE,SAAS;AACX;AACA;EACE,WAAW;EACX,YAAY;EACZ,yBAAyB;EACzB,cAAc;EACd,yBAAyB;EACzB,kBAAkB;EAClB,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,eAAe;AACjB;AACA;EACE,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,eAAe;AACjB;AACA;EACE,cAAc;EACd,gBAAgB;EAChB,eAAe;EACf,YAAY;AACd;AACA;EACE,cAAc;EACd,yBAAyB;EACzB,yBAAyB;AAC3B;AACA;EACE,aAAa;AACf;;AAEA;EACE;IACE,SAAS;EACX;AACF;AACA;EACE;IACE,WAAW;IACX,YAAY;IACZ,eAAe;IACf,YAAY;EACd;EACA;IACE,WAAW;IACX,YAAY;IACZ,eAAe;IACf,YAAY;EACd;;EAEA;IACE,eAAe;EACjB;EACA;IACE,eAAe;EACjB;EACA;IACE,cAAc;EAChB;EACA;IACE,aAAa;EACf;AACF","sourcesContent":[".pageItem {\n  width: 42px;\n  height: 42px;\n  border: 2px solid #68ad3f;\n  color: #68ad3f;\n  border-radius: 4px;\n  padding: 8px;\n  text-align: center;\n  cursor: pointer;\n  font-weight: 500;\n  font-size: 16px;\n}\n.page-gap {\n  gap: 18px;\n}\n.pageItemSelected {\n  width: 42px;\n  height: 42px;\n  border: 2px solid #68ad3f;\n  color: #ffffff;\n  background-color: #68ad3f;\n  border-radius: 4px;\n  padding: 8px;\n  text-align: center;\n  cursor: pointer;\n  font-weight: 500;\n  font-size: 16px;\n}\n.prevNext {\n  color: #68ad3f;\n  cursor: pointer;\n  font-weight: 500;\n  font-size: 16px;\n}\n.prevNextDisabled {\n  color: #68ad3f;\n  font-weight: 500;\n  font-size: 16px;\n  opacity: 0.3;\n}\n.pageItem:hover {\n  color: #ffffff;\n  border: 2px solid #fbb040;\n  background-color: #fbb040;\n}\n.mob {\n  display: none;\n}\n\n@media only screen and (min-width: 0px) and (max-width: 800px) {\n  .page-gap {\n    gap: 10px;\n  }\n}\n@media only screen and (min-width: 0px) and (max-width: 767px) {\n  .pageItem {\n    width: 20px;\n    height: 20px;\n    font-size: 10px;\n    padding: 2px;\n  }\n  .pageItemSelected {\n    width: 20px;\n    height: 20px;\n    font-size: 10px;\n    padding: 2px;\n  }\n\n  .prevNext {\n    font-size: 20px;\n  }\n  .prevNextDisabled {\n    font-size: 20px;\n  }\n  .mob {\n    display: block;\n  }\n  .web {\n    display: none;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
